import React from 'react';
import cn from 'classnames';
import { applyClasses, applyProps } from '../shared/js';
import PropTypes from 'prop-types';

import styles from './packages.module.scss';

const Row = ({ children, ...props }) => (
  <div
    className={cn(
      styles.packagesRow,
      // eslint-disable-next-line react/prop-types
      props.className,
      applyClasses(props, styles)
    )}
    {...applyProps(props)}
  >
    {children}
  </div>
);

Row.propTypes = {
  /** The Package Card children */
  children: PropTypes.any,
};

Row.defaultProps = {
  children: undefined,
};

export default Row;
